<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <app-bar :title="`Nhập thiết bị`"/>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-card-text class="pa-10">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.refCode" label="Mã phiếu nhập hàng"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field v-model="form.remark" label="Ghi chú"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-toolbar card color="white">
              <v-btn outline round color="primary" @click="pickFile" v-model="fileName">
                {{fileName}}
                <v-icon right>attach_file</v-icon>
              </v-btn>
              <input
                type="file"
                style="display: none"
                ref="fileUpload"
                accept=".xlsx, .xls, .csv"
                @change="onFilePicked"
              >
              <v-spacer></v-spacer>
              <v-btn
                flat
                round
                color="success"
                href="/static/Import_Device_Template.xlsx"
                target="_blank"
              >Tải file mẫu
                <v-icon right>cloud_download</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0">
              <import-device-table :isLoading="isLoading" :datasource="form.devices"/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="cancel()">Nhập lại</v-btn>
              <v-btn color="primary" @click="submit()" :loading="isImporting">Nhập thiết bị</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import XLSX from 'xlsx';
import * as Utils from '@/utils';
import AppBar from '@/components/appbar';
import ImportDeviceTable from './components/importlist';

export default {
  components: {
    ImportDeviceTable,
    AppBar
  },
  data () {
    return {
      fileName: 'Chọn file',
      form: {
        devices: [],
        refCode: '',
        remark: ''
      },
      isLoading: false,
      isImporting: false
    };
  },
  methods: {
    ...mapActions(['importDevices']),
    pickFile () {
      this.$refs.fileUpload.click();
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.parseExcelFileToJson(files[0]);
      }
    },
    parseExcelFileToJson (f) {
      this.isLoading = true;

      this.fileName = `Đã chọn: ${f.name}`;

      let reader = new FileReader();
      reader.readAsBinaryString(f);

      reader.onload = e => {
        let data = e.target.result;
        let workbook = XLSX.read(data, {
          type: 'binary'
        });
        let first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let content = XLSX.utils.sheet_to_json(first_worksheet, {
          header: 1
        });

        this.form.devices = [];

        content.map((item, index) => {
          if (index > 0) {
            let device = {
              imei: item[1],
              deviceType: item[2]
            };
            if (device.imei && device.deviceType) {
              this.form.devices.push(device);
            }
          }
          return 0;
        });
        this.isLoading = false;
      };
    },
    cancel () {
      window.location.reload();
    },
    submit () {
      if (this.form.devices.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }
      this.isImporting = true;
      this.importDevices(this.form)
        .then(res => {
          this.isImporting = false;
          if (res.success === res.total) {
            window.getApp.showMessage(`Nhập thành công ${res.total} thiết bị`);
            window.history.back();
          } else {
            if (res.success > 0) {
              window.getApp.showMessage(
                `Nhập thành công ${res.success} thiết bị`
              );
            }
            if (res.fail > 0) {
              this.form.devices = res.failList;
              window.getApp.showMessage(
                `Nhập thất bại ${res.fail} thiết bị`,
                'error'
              );
            }
          }
        })
        .catch(_ => {
          this.isImporting = false;
          window.getApp.showMessage(
            'Nhập thiết bị thất bại, vui lòng thử lại',
            'error'
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/device/import.vue